import { css } from '@emotion/core'

export const container = css`
	height: 28px;
	width: 28px;
	padding: 8px 8px 8px 10px;
	border-radius: 50%;
	background: rgba(225, 225, 225, 0.67);
`